import './styles.css';

export const Coin = ({ size = 50, style={} }: { size?: number, style?: React.CSSProperties }) => {
	return <div className="no-thanks__coin" style={{ width: size, height: size, ...style }} />;
};